import { supabase } from "../supabaseClient";


async function getBenefitPlans(benefitPlanId, planName, aopQopType) {

  let query = supabase
    .from('BenefitPlans')
    .select(`*`, { count: 'exact' });

  if (benefitPlanId) {
    query = query.eq("benefitPlanId", benefitPlanId).maybeSingle();
  }


  if (aopQopType && aopQopType != "All") {
    query = query.eq("aopQopType", aopQopType);
  }

  if (planName) {
    query = query.ilike("planName", '%' + planName + '%');
  }


  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;

}


async function insertBenefitPlan(postBody) {
  return await insertQuery("BenefitPlans", postBody).select("*").maybeSingle();
}

async function updateBenefitPlan(postBody, benefitPlanId) {
  return await updateQuery("BenefitPlans", postBody).eq("benefitPlanId", benefitPlanId).select("*").maybeSingle();
}


async function deleteBenefitPlan(benefitPlanId) {
  let query = await supabase
    .from('BenefitPlans')
    .delete().eq("benefitPlanId", benefitPlanId);

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}


function insertQuery(tableName, postData) {
  let _postBody = { ...postData };
  _postBody.last_updated_at = Date.now();

  return supabase.from(tableName).insert(_postBody);
}


function updateQuery(tableName, postData) {
  let _postBody = { ...postData };
  _postBody.last_updated_at = Date.now();

  return supabase.from(tableName).update(_postBody);
}

export {
  getBenefitPlans,
  insertBenefitPlan,
  deleteBenefitPlan,
  updateBenefitPlan
}